import { makeReducer } from '../utils/redux.tools';
import { SearchActions } from '../actions/search.actions';

const initialState = {
    results: {
        cmsResults: [],
        dmsResults: [],
        dmsAttachResults: []
    },
    isSearching: false,
    redirectUrl: null
};

const searchRed = {
    [SearchActions.PERFORM_SEARCH]: state => ({
        ...state,
        isSearching: true
    }),
    [SearchActions.RETURN_SEARCH_RESULTS]: (state, payload) => ({
        ...state,
        results: payload,
        isSearching: false
    }),
    [SearchActions.RETURN_REDIRECT]: (state, payload) => ({
        ...state,
        redirectUrl: payload
    }),
    [SearchActions.CLEAR_REDIRECT]: state => ({
        ...state,
        redirectUrl: null,
    })
};

export const searchReducer = makeReducer('Search', initialState, searchRed);
